/**
 * The Invited pill's avatar stack (CONTEXT.md "Invitee avatars"): up to the
 * 6 newest invitee avatars, a null entry being an invitee with no avatar,
 * plus a `+N` overflow bubble for the invitees beyond them.
 */
export interface InviteeStackView {
  avatars: (string | null)[]
  overflow: number
}

const MAX_AVATARS = 6

export function deriveInviteeStack(
  avatars: (string | null)[] | undefined,
  inviteCount: number,
): InviteeStackView {
  // No avatar data (still loading, or the endpoint failed) → plain pill.
  if (!avatars || avatars.length === 0) return { avatars: [], overflow: 0 }
  const shown = avatars.slice(0, MAX_AVATARS)
  return { avatars: shown, overflow: Math.max(0, inviteCount - shown.length) }
}
